import * as _ from 'lodash'
// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService, SettingService } from '../../common/modules/core/services';
// Models
import { BusScheduleTemplate, BusSchedule } from '../models/BusModels'
import { BehaviorSubject } from '../../../node_modules/rxjs';

@Injectable()
export class BusServices {
    private apiUrl: string;
    private busScheduleTemplate: string;
    private createBus: string = '/create-bus';
    private busListImport: string;
    private busScheduleImport: string;
    private exportStudentTemplate: string = '/bus-planning-export';
    private busSchedule: string;
    private busTransportExport: string = '/export-drop-off';
    private bus: string;
    private busStatistic: string;
    private busTransaction: string;
    private busTransactionHostess: string = '/bus-transaction-hostess'
    private reportReasons: string;
    private hostess: string;
    private hostessImport: string = '/hostess-import';
    private hostessImportImage: string = '/hostess-image-import';
    private busTransactionList: string;
    private notifications: string;
    private notiFinishedRoute: string;


    private guardian: string;
    private guardianImport: string = '/guardian-import'
    private guardianImportImage: string = "/guardian-image-import";

    //check-attendance
    private busTracking: string = '/bus-tracking';
    private checkBusTracking: string = '/check-bus-tracking';
    private busTrackingList: string = '/bus-tracking-list'
    private sendSMS: string = '/sms-send-manual';
    private smsHistory: string = '/sms-history';
    private busLocation: string = '/bus-locations';

    //language
    private language: string;
    private phrase: string;
    private content: string;
    private addPhrase: string = '/create-phrase';
    private addContent: string = '/create-content';

    // on setting - student list (add/update)
    private Status = new BehaviorSubject({ 'isUpdate': false, 'isSuccess': false });
    submitStatus = this.Status.asObservable();

    // Student
    private studentList: string;
    private students: string;
    private studentImport: string = '/student-import';
    private studentImages: string;
    private studentImageUpload: string = '/student-image-import'

    private yearGroups: string = '/year-group';
    private gradeClasses: string = '/gradeClasses';

    private smsTemplates: string;
    private settings: string;
    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain');
        this.bus = '/bus';
        this.busScheduleTemplate = '/bus-template';
        this.busListImport = '/bus-import';
        this.busScheduleImport = '/bus-planning-import';
        this.busSchedule = '/bus-schedule';
        this.busStatistic = '/bus-statistic';
        this.busTransaction = '/bus-transaction';
        this.busTransactionList = '/bus-transaction-list';
        this.reportReasons = '/reason';
        this.hostess = '/hostess';
        this.students = '/bus-students';
        this.studentImages = '/student-images';
        this.language = '/language';
        this.phrase = '/phrase';
        this.content = '/content';
        this.guardian = '/guardian';
        this.studentList = '/student-list';
        this.smsTemplates = '/sms-templates';
        this.settings = '/settings';
        this.notifications = '/notifications';
        this.notiFinishedRoute = '/notifications/finishedRoute';
    }

    /**
    * @Jira task: SBMS-
    * @author: 
    * @description: 
    */
    getStudentLocation(query: any) {
        let i = 0;
        let string = '?';

        _.forEach(query, (val, key) => {
            if (val) {
                string = !i ? string + key + '=' + val : string + '&' + key + '=' + val;
                i++;
            }
        })

        let requestUrl = this.apiUrl + this.busLocation + string;
        return this.apiService.get(requestUrl);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // change status for update/add student
    changeStatus(isUpdate: boolean, isSuccess: boolean) {
        this.Status.next({ isUpdate, isSuccess })
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Get all bus schedule with condition
    getBusSchedule(filter: any): Observable<any> {
        let requestUrl = this.apiUrl + this.busSchedule;
        const body = JSON.stringify({ filter: filter });
        return this.apiService.post(requestUrl, body);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Get schedules template of all buses
    getScheduleTemplate(): Observable<BusScheduleTemplate[]> {
        let requestUrl = this.apiUrl + this.busScheduleTemplate;

        return this.apiService.get<BusScheduleTemplate[]>(requestUrl);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Export imported schedules template
    exportScheduleTemplate(): Observable<any> {
        let requestUrl = this.apiUrl + this.exportStudentTemplate;

        return this.apiService.get<any>(requestUrl);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Get Schedules with condition
    getSchedules(start: any, end: any): Observable<BusScheduleTemplate[]> {
        let requestUrl = this.apiUrl + this.busScheduleTemplate + '?from=' + start + '&to=' + end;

        return this.apiService.get<BusScheduleTemplate[]>(requestUrl);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Post new bus info
    postNewBus(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.createBus;
        return this.apiService.post<any>(requestUrl, query);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Import Bus List Template from file .xlsx
    importBusList(data: FormData): Observable<any> {
        let requestUrl = this.apiUrl + this.busListImport;

        return this.apiService.post<any>(requestUrl, data);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Import Schedule Template from file .xlsx
    postScheduleTemplate(data: FormData): Observable<any> {
        let requestUrl = this.apiUrl + this.busScheduleImport;

        return this.apiService.post<BusScheduleTemplate[]>(requestUrl, data);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Get bus info with condition
    getBusInfo(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.bus;

        return this.apiService.post(requestUrl, query);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Get bus statistic with condition
    getBusAttendanceList(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.busStatistic;

        return this.apiService.post(requestUrl, query);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Get bus statistic with condition
    exportBusTransportList(query: any) {
        let requestUrl = this.apiUrl + this.busTransportExport + '?date=' + query.date + '&from_time=' + query.from_time + '&to_time=' + query.to_time + '&width=20in&height=15in&zoom=3';
        return requestUrl;
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Get bus report reason list
    getReportReasons(): Observable<any> {
        let requestUrl = this.apiUrl + this.reportReasons;

        return this.apiService.get(requestUrl);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Post to update specific reason
    postReason(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.reportReasons;

        return this.apiService.post(requestUrl, query);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    //
    postNotiFinishedRoute(query: any): Observable<any> {
        let requestUrl = this.apiUrl + '-noti' + this.notiFinishedRoute;

        return this.apiService.post(requestUrl, query);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    //
    postNotifications(query: any): Observable<any> {
        let requestUrl = this.apiUrl + '-noti' + this.notifications;

        return this.apiService.post(requestUrl, query);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // 
    postBusTransaction(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.busTransaction;

        return this.apiService.post(requestUrl, query);
    }


    //Post Bus transactionList
    postBusTransactionList(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.busTransactionList;

        return this.apiService.post(requestUrl, query);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Get hostess list
    getHostess(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.hostess;

        return this.apiService.post<any>(requestUrl, query);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Control Hostess
    postCtrHostess(query: any, action: string): Observable<any> {
        let requestUrl = this.apiUrl + this.hostess + '/ctr';
        switch (action) {
            case 'add':
                return this.apiService.post<any>(requestUrl, query);
            case 'update':
                return this.apiService.patch<any>(requestUrl, query);
            case 'delete':
                return this.apiService.deletePost<any>(requestUrl, query);
        }
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Import Hostess Template from file .xlsx
    importHostess(data: FormData): Observable<any> {
        let requestUrl = this.apiUrl + this.hostessImport;
        return this.apiService.post<any>(requestUrl, data);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Import Hostess Image from file .zip
    importHostessImage(data: FormData): Observable<any> {
        let requestUrl = this.apiUrl + this.hostessImportImage;
        return this.apiService.post<any>(requestUrl, data);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Change Bus Hostess
    postChangeHostess(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.busTransactionHostess;

        return this.apiService.post(requestUrl, query);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Get student list for bus
    getStudents(query: any): Observable<any> {
        let i = 0;
        let string = '?';

        _.forEach(query, (val, key) => {
            if (val) {
                string = !i ? string + key + '=' + val : string + '&' + key + '=' + val;
                i++;
            }
        })

        let requestUrl = this.apiUrl + this.students + string;
        return this.apiService.get<any>(requestUrl);
    }

    //get list student images

    getStudentImages(query: any): Observable<any> {
        let string = '/' + query;
        let requestUrl = this.apiUrl + this.studentImages + string;
        return this.apiService.get<any>(requestUrl);
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Import student list
    importStudent(data: FormData): Observable<any> {
        const requestUrl = this.apiUrl + this.students;

        return this.apiService.patch<any>(requestUrl, data);
    }




    // ────────────────────────────────────────────────────────────────────────────────
    // Import student image by file .zip
    importStudentImage(data: FormData): Observable<any> {
        const requestUrl = this.apiUrl + this.studentImageUpload;

        return this.apiService.post<any>(requestUrl, data);
    }

    //get all language
    getLanguages(): Observable<any> {
        let requestUrl = this.apiUrl + this.language;

        return this.apiService.get<any>(requestUrl);
    }

    //create language
    postLanguage(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.language;
        return this.apiService.post(requestUrl, query);
    }

    //update language
    postChangeLanguage(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.language;
        return this.apiService.patch(requestUrl, query);
    }

    //get all Phrase
    getAllPhrases(): Observable<any> {
        let requestUrl = this.apiUrl + this.phrase;

        return this.apiService.get<any>(requestUrl);
    }

    getPhrases(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.phrase;

        return this.apiService.post(requestUrl, query);
    }

    //add new Phrase

    postPhrase(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.addPhrase;
        return this.apiService.post(requestUrl, query);
    }


    //update Phrase

    postChangePhrase(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.phrase;
        return this.apiService.patch(requestUrl, query);
    }


    //get content
    getContent(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.content;
        return this.apiService.post(requestUrl, query);
    }


    //add new Content
    postContent(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.addContent;
        return this.apiService.post(requestUrl, query);
    }

    //Update Content
    postChangeContent(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.content;
        return this.apiService.patch(requestUrl, query);
    }

    //destroy Content
    destroyContent(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.content;
        return this.apiService.deletePost(requestUrl, query);
    }

    //get guardian
    getGuardian(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.guardian;
        return this.apiService.post(requestUrl, query);
    }
    // Import guardian Template from file .xlsx
    importGuardian(data: FormData): Observable<any> {
        let requestUrl = this.apiUrl + this.guardianImport;
        return this.apiService.post<any>(requestUrl, data);
    }

    // Import guardian Image from file .zip
    importGuardianImage(data: FormData): Observable<any> {
        let requestUrl = this.apiUrl + this.guardianImportImage;
        return this.apiService.post<any>(requestUrl, data);
    }

    //get student
    getStudentList(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.studentList;
        return this.apiService.post(requestUrl, query);
    }

    // Import student Template from file .xlsx
    importStudentList(data: FormData): Observable<any> {
        let requestUrl = this.apiUrl + this.studentImport;
        return this.apiService.post<any>(requestUrl, data);
    }

    // ------------------------------- >>

    //get student to update/show detail

    getStudent(data: any): Observable<any> {
        let requestUrl = this.apiUrl + this.students + '/' + data;

        return this.apiService.get<any>(requestUrl);
    }


    //get year level

    getYearGroup(): Observable<any> {
        let requestUrl = this.apiUrl + this.yearGroups;

        return this.apiService.get<any>(requestUrl);
    }



    //get grade_class

    getGradeClass(): Observable<any> {
        let requestUrl = this.apiUrl + this.gradeClasses;

        return this.apiService.get<any>(requestUrl);
    }

    //update student depend on ID
    updateStudent(query: any, data: any): Observable<any> {
        let requestUrl = this.apiUrl + this.students + '/' + data;
        return this.apiService.patch(requestUrl, query);
    }

    //create new student (and maybe guardian)
    addStudent(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.students;
        return this.apiService.post(requestUrl, query);
    }

    //Create Bus-Tracking
    postBusTracking(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.busTracking;
        return this.apiService.post(requestUrl, query);
    }

    //Update Bus-tracking
    patchBusTracking(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.busTracking + '/' + query.id;
        return this.apiService.patch(requestUrl, query);
    }

    /**
    * @Jira task: 
    * @author: 
    * @description: 
    */
   getBusTrackingList(query: any){
        let requestUrl = this.apiUrl + this.busTrackingList;
        return this.apiService.post(requestUrl, query);
   }

    //check Bus-tracking
    getBusTracking(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.checkBusTracking;
        return this.apiService.post(requestUrl, query);
    }
    //send SMS manual single/multi
    sendSMSManual(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.sendSMS;
        return this.apiService.post(requestUrl, query);
    }

    //Get SMS History
    getSMSHistory(data: any): Observable<any> {
        let requestUrl = this.apiUrl + this.smsHistory + '?pupilCode=' + data.pupil_code + '&date=' + data.date + '&expectedTime=' + data.expected_time;
        return this.apiService.get(requestUrl);
    }

    //Post Save SMS History
    postSMSHistory(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.smsHistory;
        return this.apiService.post(requestUrl, query);
    }

    /**
    * @Jira task: SBMS-139
    * @author: tri.le
    * @description:  auto-complete for guardianID
    * @params: guardianID
    * @returns: guarlist
    */
    searchByGuardianID(query: any, guardianID: Observable<string>) {
        return guardianID.debounceTime(700) //until it lets the next data through
            .distinctUntilChanged() //will ensure that only distinct data passes through
            .switchMap(guardianID => { //combines multiple possible observables received from the searchEntries method into one
                query.search.guardianid = guardianID;
                return this.getGuardIDList(query);
            });
    }

    getGuardIDList(query: any): Observable<any> {
        let requestUrl = this.apiUrl + this.guardian;
        return this.apiService.post(requestUrl, query);
    }

    getSmsTemplates(query: any){
        let requestUrl = this.apiUrl + this.smsTemplates + this.convertObjectTorequestGet(query);
        return this.apiService.get(requestUrl);
    }

    addSmsTemplates(body: any){
        let requestUrl = this.apiUrl + this.smsTemplates;
        return this.apiService.post(requestUrl, body);
    }

    updateSmsTemplates(body: any, id: any): Observable<any> {
        let requestUrl = this.apiUrl + this.smsTemplates + '/' + id;
        return this.apiService.put(requestUrl, body);
    }

    convertObjectTorequestGet(query: any){
        let i = 0;
        let string = '?';

        _.forEach(query, (val, key) => {
            if (val) {
                string = !i ? string + key + '=' + val : string + '&' + key + '=' + val;
                i++;
            }
        });

        return string;
    }

    getSettings(query: any){
        let requestUrl = this.apiUrl + this.settings + this.convertObjectTorequestGet(query);
        return this.apiService.get(requestUrl);
    }

    addSettings(body: any){
        let requestUrl = this.apiUrl + this.settings;
        return this.apiService.post(requestUrl, body);
    }

    updateSettings(body: any, id: any): Observable<any> {
        let requestUrl = this.apiUrl + this.settings + '/' + id;
        return this.apiService.put(requestUrl, body);
    }

    getLocationOfBus(query: any){
        const url = this.apiUrl + this.busLocation;
        const param = this.queryBuilder(query);

        return this.apiService.get(url + param);
    }

    snapToRoadApi(payload: any){
        const url = "https://roads.googleapis.com/v1/snapToRoads";
        const param = this.queryBuilder(payload);

        return this.apiService.getToThirdParty(url + param);
    }

    queryBuilder(query: any){
        let string = '?';
        let i = 0;
        _.forEach(query, (val: any, key: any) => {
            if (val) {
                string = !i ? string + key + '=' + val : string + '&' + key + '=' + val;
                i++;
            }
        });

        return string;
    }

    saveBusLocation(data: any) {
        const url = this.apiUrl + this.busLocation;
        return this.apiService.post(url, data);
    }

}


// WEBPACK FOOTER //
// ./src/bus/services/BusServices.ts